module.exports = __webpack_public_path__ + "media/images/locations/circle/chicago-8eadebc01ebcd57e25ca026bd9184649.jpg";